import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Attacker", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pa-4" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pa-4" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Defender", -1)


import PlayerInfoTile from "./PlayerInfoTile.vue";
import { PlayerInfo } from "@/stores/gameStore";

type Props = {
  attackerInfo: PlayerInfo;
  defenderInfo: PlayerInfo;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerInfoView',
  props: {
    attackerInfo: null,
    defenderInfo: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { class: "pa-6" }, {
        default: _withCtx(() => [
          _createVNode(PlayerInfoTile, {
            name: __props.attackerInfo.name,
            avatar: __props.attackerInfo.profilePic,
            rating: __props.attackerInfo.rating
          }, null, 8, ["name", "avatar", "rating"]),
          _hoisted_1,
          _hoisted_2,
          _createVNode(_component_v_divider),
          _hoisted_3,
          _hoisted_4,
          _createVNode(PlayerInfoTile, {
            name: __props.defenderInfo.name,
            avatar: __props.defenderInfo.profilePic,
            rating: __props.defenderInfo.rating
          }, null, 8, ["name", "avatar", "rating"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})